export default "__VITE_PUBLIC_ASSET__64c86f76__"